export * from "./clamp.directive";
export * from "./clamp.module";

